import {
    Component,
    OnDestroy,
    ViewChild,
    ChangeDetectionStrategy,
    inject,
} from '@angular/core';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { FormControl } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormSelectCellRendererParams } from '../../../../../core/models/grid/form-select-cell-renderer-params';
import { DropdownOption } from '../../../../../core/models/dropdown-option';
import { Subject, takeUntil, tap } from 'rxjs';
import { DropdownService } from '../../../../../core/services/resources/dropdown.service';
import { FormCellRendererBaseComponent } from '../form-cell-renderer-base/form-cell-renderer-base.component';
import { SelectTypeaheadDirective } from '../../../../directives/select-typeahead/select-typeahead.directive';

@Component({
    selector: 'app-form-select-cell-renderer',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatFormFieldModule,
        SelectTypeaheadDirective,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './form-select-cell-renderer.component.html',
})
export class FormSelectCellRendererComponent
    extends FormCellRendererBaseComponent<FormSelectCellRendererParams>
    implements OnDestroy
{
    @ViewChild('inputElement') inputElement!: MatSelect;
    private readonly dropdownService = inject(DropdownService);

    dropdownData: DropdownOption[] = [];
    protected destroy$ = new Subject<void>();

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    agInit(params: FormSelectCellRendererParams): void {
        this.params = params;

        this.formControl = params.context.formArray
            .at(params.node.rowIndex)
            .get(params.column?.getColId()) as FormControl;

        if (this.params.dropdownDataFunction) {
            this.params
                .dropdownDataFunction(params)
                .subscribe((options: DropdownOption[]) => {
                    this.dropdownData = options;
                });
        } else if (this.params.referenceDataType) {
            this.dropdownService
                .get(
                    this.params.referenceDataType,
                    this.params.dropdownDataOptions,
                )
                .pipe(
                    takeUntil(this.destroy$),
                    tap((options: DropdownOption[]) => {
                        this.dropdownData = options;
                    }),
                )
                .subscribe();
        }
    }

    onFocus(): void {
        if (this.shouldFocus()) {
            this.inputElement.focus();
            this.isFocusedState.set(true);
        }
    }
}
